import n from "rfdc";
import { isVNode as l, Comment as s, Fragment as u } from "vue";
import h from "lodash/fromPairs";
import d from "lodash/differenceWith";
import i from "lodash/toPairs";
import f from "lodash/isEqual";
function x(e, r = "px") {
  if (!(e == null || e === ""))
    return isNaN(e) ? String(e) : `${Number(e)}${r}`;
}
function m(e) {
  const r = /* @__PURE__ */ Object.create(null);
  return function(c) {
    return r[c] || (r[c] = e(c));
  };
}
const q = m((e) => e.charAt(0).toUpperCase() + e.slice(1));
function o(e) {
  return e.some((r) => l(r) ? r.type === s ? !1 : r.type !== u || o(r.children) : !0);
}
function y(e, r = "default", a = {}) {
  const c = e.$slots[r];
  let t;
  return c && (t = c(a)), Array.isArray(t) ? o(t) : !1;
}
const z = {
  backspace: 8,
  enter: 13,
  esc: 27,
  space: 32,
  end: 35,
  home: 36,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  delete: 46,
  shift: 16,
  ctrl: 17,
  tab: 9,
  pageUp: 33,
  pageDown: 34
};
function N(e, r) {
  return h(d(i(r), i(e), f));
}
function $(e, r, a) {
  return e > a ? a : e < r ? r : e;
}
function A(e) {
  return {
    "alert-circle": "alert",
    "alert-circle-solid": "alert",
    "alert-octagon": "alert",
    "alert-triangle": "alert",
    "arrow-down-circle": "arrow-down",
    "arrow-left-circle": "arrow-left",
    "arrow-right-circle": "arrow-right",
    "arrow-up-circle": "arrow-up",
    "bar-chart-2": "bar-chart",
    "chart-area-stacked": "chart-area",
    "chart-area-stacked-relative": "chart-area",
    "chart-bar-stacked": "chart-bar",
    "chart-bar-stacked-relative": "chart-bar",
    "chart-column-stacked": "chart-column",
    "chart-column-stacked-relative": "chart-column",
    "check-circle": "check",
    "check-circle-2": "check",
    "check-circle-2-solid": "check",
    "check-square": "check",
    "chevron-down-square": "chevron-down",
    "divide-square": "divide",
    "divide-circle": "divide",
    "draggable-horizontal": "draggable",
    "draggable-vertical": "draggable",
    "edit-2": "edit",
    "edit-3": "edit",
    "help-circle": "help",
    "info-solid": "info",
    "link-2": "link",
    "maximize-2": "maximize",
    "message-circle": "message",
    "message-square": "message",
    "minimize-2": "minimize",
    "minus-circle": "minus",
    "minus-circle-solid": "minus",
    "minus-square": "minus",
    "more-horizontal": "more",
    "more-vertical": "more",
    "navigation-2": "navigation",
    "play-circle": "play",
    "plus-cricle": "plus",
    "plus-square": "plus",
    "refresh-ccw": "refresh-counter-clockwise",
    "refresh-cw": "refresh-clockwise",
    "roadmaps-backlog-solid": "roadmaps-backlog",
    "rocket-2": "rocket",
    "rotate-ccw": "rotate-counter-clockwise",
    "rotate-cw": "rotate-clockwise",
    "share-2": "share",
    "stop-circle": "stop",
    "trash-2": "trash",
    "x-circle": "x",
    "x-octagon": "x",
    "x-square": "x"
  }[e] || e;
}
const C = n();
function D(e) {
  return e ? "$el" in e ? e.$el : e : null;
}
export {
  m as cached,
  q as capitalize,
  $ as clamp,
  C as cloneDeep,
  x as convertToUnit,
  N as getShallowObjectDiff,
  y as hasSlot,
  o as hasValidVNode,
  A as iconTypeToGeneric,
  z as keyCodes,
  D as unwrapElement
};
//# sourceMappingURL=utils.js.map
